import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { OpportunityDetailsNavModel } from '../../common/models/opportunity-details.model';
import { ArchiveDetailsUpdatingModel } from '../../common/models/wbs-picker.model';
import { IntakeConstant } from '../constants/intake.constant';
import {
  DOCUMENT_SUBMISSION_STATUS_ID_MAPPER,
  IntakeOppertunitySubmissionStatus,
} from '../constants/intake-submission-status.enum';
import { IntakeDocumentSubmissionTypeCode } from '../constants/intake-submission-type.enum';
import {
  ADDITIONAL_RM_REVIEW_REVIEW_STATUS_ALLOWED_ROLES,
  DRAFT_FOR_REVIEW_DOC_STATUS_NOT_ALLOWED_ROLES,
} from '../opportunity-details/submission-common-section/document/document-settings';
import { DocumentStatus } from '../constants/document-status.enum';

export const commonSectionForSingleCoCheck = (
  submissionData: OpportunityDetailsNavModel[]
) => {
  return (
    submissionData.length === 1 &&
    (submissionData[0].submissionTypeCode ===
      IntakeDocumentSubmissionTypeCode.CO ||
      submissionData[0].submissionTypeCode ===
        IntakeDocumentSubmissionTypeCode.OTH) /*US5829162*/
  );
};

export const randomString = (length: number = 15) => {
  let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};

export const capitalizeFirstLetter = (val: string) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

export const copyToClipboard = (value: string) => {
  if (value) {
    navigator.clipboard.writeText(value).then(
      () => {},
      (err) => {
        console.error('Could not copy text: ', err);
      }
    );
  }
};

export const setArchiveDetails = (
  value: string,
  archiveFolderArrValue: string[]
): ArchiveDetailsUpdatingModel => {
  return {
    archiveNumber: value ?? IntakeConstant.EMPTY_SPACE,
    archiveName: value ?? IntakeConstant.EMPTY_SPACE,
    archiveID: value ?? IntakeConstant.EMPTY_SPACE,
    archiveFolder: value ?? IntakeConstant.EMPTY_SPACE,
    archiveFoldersArray: archiveFolderArrValue ?? [],
    clientName: value ?? IntakeConstant.EMPTY_SPACE,
    clientNumber: value ?? IntakeConstant.EMPTY_SPACE,
    partner: value ?? IntakeConstant.EMPTY_SPACE,
    business: value ?? IntakeConstant.EMPTY_SPACE,
    archiveDescription: value ?? IntakeConstant.EMPTY_SPACE,
    archiveStatus: value ?? IntakeConstant.EMPTY_SPACE,
  };
};

export const convertDate = (data: string): string => {
  const [datePart] = data.split(' ');
  const [month, day, year] = datePart.split('/');
  return `${month}/${day}/${year}`;
};

export const convertTime = (data: string): string => {
  const [, timePart, period] = data.split(' ');
  const [hours, minutes] = timePart.split(':');
  return `${hours}:${minutes} ${period}`;
};

export function isTheDocumentHasCompletedElSOw(
  opportunityDetails: OpportunityDetailsNavModel[]
): boolean {
  return opportunityDetails?.some(
    (detail: OpportunityDetailsNavModel) =>
      detail.submissionTypeCode.toString() ===
        IntakeDocumentSubmissionTypeCode.EL_SOW.toString() &&
      detail.submissionStatusId ===
        DOCUMENT_SUBMISSION_STATUS_ID_MAPPER[
          IntakeOppertunitySubmissionStatus.COMPLETED
        ]
  );
}

export function isSecondarySearchSameAsPrimarySearch(
  isSecondarySearch: boolean,
  primaryOpportunityId: string,
  secondaryOpportunityId: string
): boolean {
  const primaryOppNumber: string =
    removeAlphabetsFromOppId(primaryOpportunityId);
  const secondaryOppNumber: string = removeAlphabetsFromOppId(
    secondaryOpportunityId
  );
  return (
    isSecondarySearch &&
    (primaryOpportunityId.toLowerCase() ===
      secondaryOpportunityId.toLowerCase() ||
      primaryOppNumber === secondaryOppNumber)
  );
}

export function removeAlphabetsFromOppId(opportunityId: string): string {
  return opportunityId.replace(/^jo-/i, IntakeConstant.EMPTY_SPACE);
}

export function excludeDraftForReviewFromDocStatus(
  loggedInUserRoles: string[],
  docStatusArray: SelectItemOptions[]
): SelectItemOptions[] {
  const riskManagerRoles: string[] =
    DRAFT_FOR_REVIEW_DOC_STATUS_NOT_ALLOWED_ROLES;
  if (
    loggedInUserRoles.some((role) => riskManagerRoles.includes(role)) &&
    loggedInUserRoles.every((role) => riskManagerRoles.includes(role))
  ) {
    const convertedArray = docStatusArray.filter(
      (item: SelectItemOptions) => item.heading !== DocumentStatus.Draft
    );

    return convertedArray;
  }
  return docStatusArray;
}

export function excludeAdditionalRMReviewRqdFromDocStatus(
  loggedInUserRoles: string[],
  docStatusArray: SelectItemOptions[],
  submissionStatus: string
): SelectItemOptions[] {
  const riskManagerRoles: string[] =
    ADDITIONAL_RM_REVIEW_REVIEW_STATUS_ALLOWED_ROLES;
  if (
    !loggedInUserRoles.some((role) => riskManagerRoles.includes(role)) ||
    (submissionStatus !== IntakeOppertunitySubmissionStatus.SUBMITTED &&
      submissionStatus !== IntakeOppertunitySubmissionStatus.RESUBMITTED)
  ) {
    const convertedArray = docStatusArray.filter(
      (item: SelectItemOptions) =>
        item.heading !== DocumentStatus.AdditionalRMReviewRequired
    );

    return convertedArray;
  }
  return docStatusArray;
}
